import React from 'react';
import noImage from '../../Images/no_image.svg';

const Image = ({ alt, ...props }) => (
  <img
    {...props}
    onError={({ currentTarget }) => {
      // eslint-disable-next-line no-param-reassign
      currentTarget.onerror = null; // prevents looping
      // eslint-disable-next-line no-param-reassign
      currentTarget.src = noImage;
      // eslint-disable-next-line no-param-reassign
      currentTarget.style.objectFit = 'contain';
      // eslint-disable-next-line no-param-reassign
      currentTarget.style.padding = '24px';
    }}
    alt={alt}
  />
);

export default Image;
